// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import ProvisioningHeader from './ProvisioningHeader';
import ProvisioningSidebar from './ProvisioningSidebar';
import ProvisioningRoutes from '../routes/ProvisioningRoutes';
import '../theme/provisioning-theme.css';
import styles from './ProvisioningShell.module.css';

/**
 * Provisioning's chrome. This app ships as its own build at its own origin, so
 * Helios' `AppShell` never mounts here — which also sidesteps ShellBody's
 * empty-site state, since a Qcells operator provisioning a new org has no
 * assigned sites.
 */
export default function ProvisioningShell() {
  // Dark theme pinning lives in ProvisioningApp.tsx: the whole build is dark
  // only, including routes outside this shell (/login).
  return (
    // `provisioning-root` is a stable (non-hashed) hook provisioning-theme.css
    // scopes its overrides to.
    <div className={`${styles.shell} provisioning-root`}>
      <ProvisioningHeader />
      <div className={styles.body}>
        <ProvisioningSidebar />
        <main className={styles.content}>
          <ProvisioningRoutes />
        </main>
      </div>
    </div>
  );
}
